// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fRcB7","text1":"styles_text1__Nena2","text2":"styles_text2__IoNGe","text3":"styles_text3__58KNW"};